export const getRandomInt = (max: number): number => {
  return Math.floor(Math.random() * max);
};
